import * as Yup from 'yup';
import { lessThanXCharsNotEndBacklashRequired } from '../../../../helpers/validationSchemaHelpers';

export const nameValidationSchema = lessThanXCharsNotEndBacklashRequired('Name', 50);

const validationSchema = Yup.object({
  IsWet: Yup.boolean(),
}).concat(nameValidationSchema);

export default validationSchema;
